import { Link } from "react-router-dom";
import { Space } from "../Layout";
import { Media, Texts, Title, Button } from "../Object";
import { Scroll } from "../Animation";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const Service = (props) => {
  return (
    <>
      <div className="l-row">
        <Title slug="service" type="border" />

        <Space size={["64px 0 0", "48px 0 0"]}>
          <Scroll>
            <List />
          </Scroll>
        </Space>
      </div>
    </>
  );
};

export const List = (props) => {
  const [modal, setModal] = useState();
  const [modalSrc, setModalSrc] = useState();
  const args = {
    length: props.length ?? 26,
  };

  const Item = (props) => {
    return (
      <>
        {/* <Button link={`/service/#service-list${props.index}`} linkType="hash"> */}
        <li
          className="p-service__items"
          onClick={() => {
            setModal(true);
            setModalSrc(`service-modal-new/list${props.index}`);
          }}
        >
          <Media
            class="p-service__img"
            src={`service/list${props.index}`}
            alt="media"
            sp="sp"
          />
          <div className="p-service__button">
            <Texts
              slug={`service/list${props.index}`}
              class="c-text--bold p-service__text"
            ></Texts>
          </div>
        </li>
        {/* </Button> */}
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }

  return (
    <>
      <ul className="p-service__list">{items}</ul>
      <AnimatePresence mode="wait">
        {modal && (
          <motion.div
            key="modal"
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: {
                duration: 0.4,
              },
            }}
            exit={{ opacity: 0 }}
          >
            <div className="p-service__modal">
              <div
                className="p-service__modal--back"
                onClick={() => {
                  setModal(false);
                  setModalSrc("");
                }}
              ></div>
              <div
                onClick={() => {
                  setModal(false);
                  setModalSrc("");
                }}
                className="p-service__modal--inner l-row"
                data-state="min"
              >
                <div className="p-service__modal--inner__box">
                  <Media src={modalSrc} alt="media"></Media>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Service;
